export const other = '';
export const userRoles = ['administrator', 'agent', 'customer', 'asset'];
export const servicesPlans = ['Standard (6K)', '12K Plan', '17K Plan', '30K Plan'];
